import { BrushFilter } from './brushFilter';
import { brushXRegion } from './brushXHighlight';
export function BrushXFilter(options) {
    return BrushFilter(Object.assign(Object.assign({ hideX: true }, options), { brushRegion: brushXRegion }));
}
//# sourceMappingURL=brushXFilter.js.map